import 'twin.macro'

import AppleIcon from 'assets/icons/AppleIcon'
import FacebookIcon from 'assets/icons/FacebookIcon'
import FFLogo from 'assets/icons/FreedomLogo'
import HuaweiIcon from 'assets/icons/HuaweiIcon'
import InstagramIcon from 'assets/icons/InstagramIcon'
import PhoneIcon from 'assets/icons/PhoneIcon'
import PlayMarketIcon from 'assets/icons/PlayMarketIcon'
import TikTokIcon from 'assets/icons/TikTokIcon'
import WhatsappIcon from 'assets/icons/WhatsApp'
import Caption from 'components/UI/caption'
import ContactItem from 'components/UI/contact/contacat-item'
import SubBody from 'components/UI/sub-body/sub-body'
import { ThemeContext } from 'contexts/theme-context'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import { forEach } from 'ramda'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import MobileFooter from '../mobile-footer'
import AppImg from './../../../assets/images/footer-app-img.webp'
function Footer() {
  const { t } = useTranslation()
  const { isMobile } = useDeviceInfo()
  const { theme } = useContext(ThemeContext)
  const counterArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  return (
    <>
      {isMobile ? (
        <MobileFooter />
      ) : (
        <>
          <div
            css={theme === 'dark' ? tw`border-[#454545]` : tw`border-[#DBDBDB]`}
            tw='w-full border border-l-0 border-r-0 border-b-0 py-6 mt-[120px]'
          >
            <div tw='max-w-landing mx-auto flex justify-between'>
              <div tw='text-green flex gap-12'>
                {/*<ContactItem*/}
                {/*  link='https://wa.me/77760595595'*/}
                {/*  placement={'footer'}*/}
                {/*  icon={<WhatsappIcon />}*/}
                {/*  label='+7 776 1 595 595'*/}
                {/*  caption={'WHATSAPP'}*/}
                {/*/>*/}
                <ContactItem
                  link='tel:595'
                  icon={<PhoneIcon />}
                  placement={'footer'}
                  label='595'
                  caption={`${t('free_call', { ns: 'footer' })}`}
                />
              </div>
              <div tw='flex gap-4'>
                <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full text-green'>
                  <a href={'/'}>{<InstagramIcon />}</a>
                </div>
                <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full text-green'>
                  <a href={'/'}>{<FacebookIcon />}</a>
                </div>
                <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full text-green'>
                  <a href={'/'}>{<TikTokIcon />}</a>
                </div>
              </div>
            </div>
          </div>
          <div
            css={theme === 'dark' ? tw`border-[#454545]` : tw`border-[#DBDBDB]`}
            tw='w-full border border-l-0 border-r-0 py-6'
          >
            <div tw='max-w-landing mx-auto flex justify-end'>
              <p tw='text-[10px] text-secondary text-right'>
                <Trans components={{ br: <br /> }}>{t('license', { ns: 'footer' })}</Trans>
              </p>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Footer
